/**
 *
 */
export interface UIFieldTypeId {
	/**
	 * variable Of string type define the type of Input Field.
	 */
	iid: string;
	/**
	 * variable of boolean type define only number allowed if true.
	 */
	isNumber: boolean;
}

/**
 * Type of Object Required For Input Field.
 */
export class FnInputModel {
	/**
	 * variable of boolean type
	 * if true then FnRequireValidator validate input field.
	 */
	isRequired: boolean;
	/**
	 * variable of number type
	 * used by FnMinValidator to validate input field.
	 */
	minLength: number;
	/**
	 * variable of string type
	 */
	labelPosition: string;
	/**
	 * variable of UIFieldTypeId.
	 */
	typeID: UIFieldTypeId;
	/**
	 * variable of type string.
	 */
	id: string;
	/**
	 * variable of type boolean
	 * if ture then disable FormControl.
	 */
	isDisabled: boolean;
	/**
	 * variabl of string type
	 * used set the name attribute of input field.
	 */
	key: string;
	/**
	 * variable of number type
	 * used by FnMaxValidator to validate input field.
	 */
	maxLength: number;
	/**
	 * Hide label
	 */
	hideLabel: boolean;
	/**
	 * option variable of string type.
	 * used by FnPattern Validator to validate input field if given.
	 */
	pattern?: string;
}
